<template>
  <CustomDropdown
    :ref="(el) => setDropdownRef(el)"
    maxHeight="300px"
    gap="10px"
    position="end"
    dropdownCSS="p-0"
    :relative-to-viewport="true"
    :disabled="!hasListAccess"
  >
    <template #trigger>
      <div class="quick_action_item mt-1">
        <a-tooltip placement="top" title="Add to list">
          <ThemeImage class="size-5" :icon="icon" alt="add_to_list" />
        </a-tooltip>
      </div>
    </template>

    <template #default>
      <CreateListDropdownComponent
        v-if="showEntityCreate"
        :source="source"
        @entity-list-created="handleEntityList"
        @go-back="showEntityCreate = false"
      />
      <div class="flex flex-col" v-else>
        <div
          v-if="entityLists?.length > 0"
          class="overflow-y-scroll max-h-[180px] w-[266px]"
        >
          <div class="p-2">
            <div
              v-for="(list, index) in entityLists"
              class="dropdown_item flex items-center flex-row gap-2 px-3 py-2 rounded-lg"
              :key="`${list.id}_list_${index}`"
              @click="handleEntityList(list)"
              :ref="(el) => setItemRef(el, list.id + '_' + index)"
            >
              <a-tooltip
                :key="`${list?.id}_list_${index}`"
                placement="top"
                :title="
                  shouldShowTooltip(list.id + '_' + index)
                    ? list?.list_name || ''
                    : ''
                "
              >
                <div class="flex w-full flex-row items-center gap-1">
                  <div
                    class="truncate"
                    :ref="(el) => setContainerRef(el, list.id + '_' + index)"
                  >
                    <span
                      :ref="(el) => setTextRef(el, list.id + '_' + index)"
                      class="text_color truncate text-sm font-normal leading-[17px]"
                      >{{ list.list_name }}
                    </span>
                  </div>
                  <ThemeImage
                    v-if="list.private_flag"
                    :icon="imageNames.LOCK_GREY"
                    alt="private_icon"
                    class="size-[14px]"
                  />
                </div>
              </a-tooltip>
            </div>
          </div>
        </div>
        <div
          :class="[
            'flex flex-col p-2',
            { border_top: entityLists?.length > 0 },
          ]"
        >
          <div
            class="dropdown_item flex items-center flex-row gap-2 px-3 py-2 rounded-lg"
            @click="handleListCreate"
          >
            + Create New List
          </div>
        </div>
      </div>
    </template>
  </CustomDropdown>
</template>

<script setup>
import { ref } from "vue";
import CustomDropdown from "@/src/components/CustomDropdown.vue";
import CreateListDropdownComponent from "@/src/components/CreateListDropdownComponent.vue";
import { imageNames } from "@/src/constants/imageConstants.js";
import { useTruncationTooltip } from "@/src/composables/useTruncationTooltip.js";

const { setTextRef, setContainerRef, shouldShowTooltip, setItemRef } =
  useTruncationTooltip();
const props = defineProps({
  row: { type: Object, required: true },
  source: { type: String, required: true },
  entityLists: { type: Array, default: () => [] },
  hasListAccess: { type: Boolean, default: true },
});

const emit = defineEmits(["entity-list-created", "list-create"]);

const dropdownRef = ref(null);
const showEntityCreate = ref(false);
const icon = imageNames.ORDERED_LIST_GREY;

const setDropdownRef = (el) => {
  dropdownRef.value = el;
};

const handleEntityList = (list) => {
  const listId = typeof list === 'object' ? list.id : list;
  const listName = typeof list === 'object' ? list.list_name : null;
  emit("entity-list-created", { listId, listName, rowId: props.row.id });
  showEntityCreate.value = false;
  dropdownRef.value?.closeDropdown();
};

const handleListCreate = () => {
  emit("list-create", props.row);
  showEntityCreate.value = true;
};
</script>
